import type { Database } from '../lib/database.types';

type Tables = Database['public']['Tables'];
export type Enums = Database['public']['Enums'];

export type Profile = Tables['profiles']['Row'];
export type UserSettings = Tables['user_settings']['Row'];
export type Group = Tables['groups']['Row'];
export type GroupMember = Tables['group_members']['Row'];
export type GroupInvitation = Tables['group_invitations']['Row'];
export type Trip = Tables['trips']['Row'];
export type TripMember = Tables['trip_members']['Row'];
export type TripStop = Tables['trip_stops']['Row'];
export type Subgroup = Tables['subgroups']['Row'];
export type SubgroupMember = Tables['subgroup_members']['Row'];
export type ItineraryEvent = Tables['itinerary_events']['Row'];
export type EventParticipant = Tables['event_participants']['Row'];
export type Booking = Tables['bookings']['Row'];
export type ChecklistItem = Tables['checklist_items']['Row'];
export type AttentionAction = Tables['attention_actions']['Row'];
export type DocumentRow = Tables['documents']['Row'];
export type TripBudget = Tables['trip_budgets']['Row'];
export type BudgetItem = Tables['budget_items']['Row'];
export type BudgetAllocation = Tables['budget_item_allocations']['Row'];
export type Expense = Tables['expenses']['Row'];
export type ExpenseShare = Tables['expense_shares']['Row'];
export type Settlement = Tables['settlements']['Row'];
export type TravelDocProfile = Tables['traveler_document_profiles']['Row'];
export type TravelCredential = Tables['travel_credentials']['Row'];
export type Destination = Tables['destination_catalog']['Row'];

export type EventCategory = Enums['event_category'];
export type EventStatus = Enums['event_status'];
export type TimePrecision = Enums['time_precision'];
export type ZoneStatus = Enums['zone_status'];

export const TRANSPORT_CATEGORIES: ReadonlySet<EventCategory> = new Set([
  'flight', 'rail', 'coach', 'ferry', 'cruise', 'road', 'rental', 'transfer',
]);

/** PostgREST returns `timestamp` as 'YYYY-MM-DDTHH:mm:ss'; the domain uses minute precision. */
export function normLocal(v: string | null | undefined): string | null {
  return v ? v.replace(' ', 'T').slice(0, 16) : null;
}

/** Event with its participants (empty list = applies to everyone who can see it). */
export interface EventWithPeople extends ItineraryEvent {
  participant_ids: string[];
}
